export default __webpack_public_path__ + "static/media/Telkey_logo_white.f2779a8e.png";